import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { UpdateContactRequest, UpdateContactResponse } from '../../../interfaces/updateContact.interface';
import { UpdateContactService } from '../../../services/updatecontact/updatecontact.service';
import { LoginService } from '../../../services/login/login.service';
import { ErrorAlertComponent } from "../../shared/error-alert/error-alert.component";
import { SuccessAlertComponent } from "../../shared/success-alert/success-alert.component";
import { LoadingService } from '../../../services/general/loading.service';
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ErrorAlertComponent, ReactiveFormsModule, SuccessAlertComponent, ConfirmationModalComponent, PageHeaderComponent],
  selector: 'app-update-contact',
  templateUrl: './updatecontact.component.html',
  styleUrl: './updatecontact.component.css'
})
export class UpdateContactComponent {
  token: string = '';
  updateContactRequest: UpdateContactRequest = {
    nit: '',
    username: '',
    new_phone: '',
    new_email: '',
    access_token_crm: ''
  };
  successMessage: string = '';
  errorMessage: string = '';
  showAlertError: boolean = false;
  showAlertSuccess: boolean = false;
  message1ForSuccesAlert = 'Actualizacion exitosa'
  message2ForSuccesAlert = ''
  isModalVisible: boolean = false
  isEmailValid: boolean = true;
  emailError: string = '';
  isPhoneValid: boolean = true;
  phoneError: string = '';
  countryCode: string = '+57';
  phoneNumber: string = '';
  countryCodes = [
    { code: '+57', country: 'Colombia', flag: '🇨🇴' },
    { code: '+1', country: 'Estados Unidos', flag: '🇺🇸' },
    { code: '+52', country: 'México', flag: '🇲🇽' },
    { code: '+54', country: 'Argentina', flag: '🇦🇷' },
    { code: '+56', country: 'Chile', flag: '🇨🇱' },
    { code: '+51', country: 'Perú', flag: '🇵🇪' },
    { code: '+55', country: 'Brasil', flag: '🇧🇷' },
    { code: '+34', country: 'España', flag: '🇪🇸' }
  ];
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Actualizar Usuario',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private updateContactService: UpdateContactService,
    private _loadingService: LoadingService,
    private _logsService: LogTackingService,
    private _tokenZohoCrm: LoginService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') || '';
  }

  onSubmit(form: NgForm): void {
    this.validateEmail();
    this.validatePhone();
    
    if (this.isEmailValid && this.isPhoneValid && form.valid) {
      this.isModalVisible = true;
    }
  }
  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 5000);
  }

  cancel(form: NgForm) {
    this.phoneNumber = '';
    this.countryCode = '+57';
    form.resetForm();
    // Restaurar el código de país después del reset
    setTimeout(() => {
      this.countryCode = '+57';
    }, 0);
  }

  onConfirm(form: NgForm) {
    this._loadingService.setLoading(true)
    
    // Concatenar código de país con número de teléfono
    this.updateContactRequest.new_phone = this.countryCode + this.phoneNumber;
    
    this._tokenZohoCrm.getTokenZohoCrm().subscribe(
      response => {
        this.updateContactRequest.access_token_crm = response.access_token
        let haveNit = this.updateContactRequest.username.substring(0, 3)
        if (haveNit !== 'nit') {
          this.updateContactRequest.username = (`nit-${this.updateContactRequest.nit}-${this.updateContactRequest.username}`).trim()
        }
        this.updateContactService.updateContact(this.token, this.updateContactRequest)
          .subscribe({
            next: (response: any) => {
              if(response.details){
                this.errorMessage = response.message
                this.log_info.details = `Error: ${this.errorMessage}`
                this.showErrorComponent(form)
  
              }else{
                this.message2ForSuccesAlert = 'Los datos de contacto de ' + this.updateContactRequest.username + ' se actualizaron correctamente.'
                this.showAlertSuccess = true
                this.log_info.details = `Success: Usuario actualizo los datos deL contacto ${this.updateContactRequest.username}`
                this.createTrackingLog()
                this._loadingService.setLoading(false)
                setTimeout(() => {
                  this.showAlertSuccess = false;
                  this.cancel(form);
                }, 5000);
              }
            },
            error: (error: any) => {
              this.errorMessage = error.error.message
              this.log_info.details = `Error: ${this.errorMessage}`
              this.showErrorComponent(form)
            }
          });
      }, error => {
        this.errorMessage = error.error.message
        this.log_info.details = `Error: ${this.errorMessage}`
        this.showErrorComponent(form)

      }
    )
    this.isModalVisible = false;
  }

  onCancel() {
    this.isModalVisible = false;
  }

  validateEmail(): void {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!this.updateContactRequest.new_email) {
      this.isEmailValid = false;
      this.emailError = 'El correo electrónico es requerido';
    } else if (!emailPattern.test(this.updateContactRequest.new_email)) {
      this.isEmailValid = false;
      this.emailError = 'El formato del correo electrónico no es válido';
    } else {
      this.isEmailValid = true;
      this.emailError = '';
    }
  }

  validatePhone(): void {
    const phoneDigits = this.phoneNumber.replace(/\s/g, '');
    
    if (!phoneDigits) {
      this.isPhoneValid = false;
      this.phoneError = 'El número de celular es requerido';
    } else if (phoneDigits.length !== 10) {
      this.isPhoneValid = false;
      this.phoneError = 'El número debe tener 10 dígitos';
    } else if (!/^[0-9]+$/.test(phoneDigits)) {
      this.isPhoneValid = false;
      this.phoneError = 'El número solo debe contener dígitos';
    } else {
      this.isPhoneValid = true;
      this.phoneError = '';
    }
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }
}
